import { render, staticRenderFns } from "./AdminManagePersonConditions.vue?vue&type=template&id=06baa182"
import script from "./AdminManagePersonConditions.vue?vue&type=script&lang=js"
export * from "./AdminManagePersonConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports